// import React, { useState, useEffect } from "react";
// import CustomSelect from "../CustomSelect/CustomSelect";

// const CheckInOut = () => {
//   const [employees, setEmployees] = useState([]);
//   const [formData, setFormData] = useState({
//     email: "",
//     date: "",
//     records: Array(5).fill(null).map(() => ({ check_in: "00:00:00", check_out: "00:00:00" })),
//   });
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-employees`)
//       .then((res) => res.json())
//       .then((data) => setEmployees(data.employees))
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   const handleSelectChange = (event) => {
//     const selectedEmail = event.target.value;
//     const selectedEmployee = employees.find((emp) => emp.email === selectedEmail);
//     if (selectedEmployee) {
//       setFormData((prev) => ({ ...prev, email: selectedEmployee.email }));
//     }
//   };

//   const handleDateChange = (e) => {
//     const selectedDate = e.target.value;
//     setFormData((prev) => ({ ...prev, date: selectedDate }));
//     if (formData.email && selectedDate) {
//       fetchCheckInOutData(formData.email, selectedDate);
//     }
//   };

//   const fetchCheckInOutData = async (email, date) => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-checkin-checkout`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, date }),
//       });
//       let records = await response.json();
//       while (records.length < 5) {
//         records.push({ check_in: "00:00:00", check_out: "00:00:00" });
//       }
//       setFormData((prev) => ({ ...prev, records: [...records] }));
//     } catch (error) {
//       console.error("Error fetching check-in/out data:", error);
//     }
//   };

//   const handleRecordChange = (index, field, value) => {
//     setFormData((prev) => {
//       const updatedRecords = prev.records.map((record, i) =>
//         i === index ? { ...record, [field]: value ? `${value}:00` : "00:00:00" } : record
//       );
//       return { ...prev, records: updatedRecords };
//     });
//   };

//   const handleSubmit = async () => {
//     if (!formData.email || !formData.date) {
//       alert("Please select an employee and date.");
//       return;
//     }
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/add-checkin-checkout`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       setMessage(response.ok ? data.message : data.error || "Error submitting data.");
//     } catch (error) {
//       setMessage("Network error. Please try again.");
//     }
//   };

//   return (
//     <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", background: "#fff", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", borderRadius: "8px" }}>
//       <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>Check-In / Check-Out</h2>
        

   

//       <label>Employee:</label>
       

//       <CustomSelect

// employees={employees} selectedEmail={formData.email} onSelect={(email) => setFormData({ ...formData, email })} />

//       <label style={{ marginTop: "15px", display: "block" }}>Date:</label>
//       <input type="date" name="date" value={formData.date} onChange={handleDateChange} style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }} />

//       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "15px", marginTop: "20px" }}>
//         {formData.records.map((record, index) => (
//           <div key={index} style={{ padding: "10px", background: "#f9f9f9", borderRadius: "5px", border: "1px solid #ddd" }}>
//             <label>Check-In {index + 1}:</label>
//             <input type="time" value={record.check_in.slice(0, 5)} onChange={(e) => handleRecordChange(index, "check_in", e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }} />
//             <label>Check-Out {index + 1}:</label>
//             <input type="time" value={record.check_out.slice(0, 5)} onChange={(e) => handleRecordChange(index, "check_out", e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }} />
//           </div>
//         ))}
//       </div>

//       <button onClick={handleSubmit} style={{ width: "100%", padding: "10px", background: "#28a745", color: "#fff", borderRadius: "5px", border: "none", cursor: "pointer", marginTop: "20px" }}>Submit</button>

//       {message && <p style={{ textAlign: "center", color: "#28a745", marginTop: "15px" }}>{message}</p>}
//     </div>
//   );
// };

// export default CheckInOut;


import React, { useState, useEffect } from "react";
import { Box, Typography, Button, useTheme, Select, MenuItem  } from '@mui/material';
import CustomSelect from "../CustomSelect/CustomSelect";
import { tokens } from "../../../../../theme";

const CheckInOut = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  
  const [employees, setEmployees] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    date: "",
    records: Array(5).fill(null).map(() => ({ check_in: "00:00:00", check_out: "00:00:00" })),
  });
  const [message, setMessage] = useState("");
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
 useEffect(() => {
  const fetchEmployees = async () => {

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-employees`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      setEmployees(data.employees);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  fetchEmployees();
}, []);

  const handleSelectChange = (event) => {
    const selectedEmail = event.target.value;
    const selectedEmployee = employees.find((emp) => emp.email === selectedEmail);
    if (selectedEmployee) {
      setFormData((prev) => ({ ...prev, email: selectedEmployee.email }));
    }
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setFormData((prev) => ({ ...prev, date: selectedDate }));
    if (formData.email && selectedDate) {
      fetchCheckInOutData(formData.email, selectedDate);
    }
  };

  const fetchCheckInOutData = async (email, date) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-checkin-checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${accessToken}`},
        body: JSON.stringify({ email, date }),
      });
      let records = await response.json();
      while (records.length < 5) {
        records.push({ check_in: "00:00:00", check_out: "00:00:00" });
      }
      setFormData((prev) => ({ ...prev, records: [...records] }));
    } catch (error) {
      console.error("Error fetching check-in/out data:", error);
    }
  };

  const handleRecordChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedRecords = prev.records.map((record, i) =>
        i === index ? { ...record, [field]: value ? `${value}:00` : "00:00:00" } : record
      );
      return { ...prev, records: updatedRecords };
    });
  };


  const handleSubmit = async () => {
    if (!formData.email || !formData.date) {
      alert("Please select an employee and date.");
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/add-checkin-checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${accessToken}`},
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      setMessage(response.ok ? data.message : data.error || "Error submitting data.");
    } catch (error) {
      setMessage("Network error. Please try again.");
    }
  };
  

  return (
    <Box 
      sx={{ 
        maxWidth: "900px", 
        margin: "40px auto", 
        padding: "20px", 
        background: colors.primary[400], 
        boxShadow: theme.shadows[1], 
        borderRadius: "8px" 
      }}
    >
      <Typography 
        variant="h2" 
        sx={{ 
          textAlign: "center", 
          marginBottom: "20px", 
          color: colors.grey[100] 
        }}
      >
        Check-In / Check-Out
      </Typography>

      <Typography 
        variant="body1" 
        sx={{ 
          color: colors.grey[100],
          marginBottom: "8px"
        }}
      >
        Employee:
      </Typography>
      
      {/* <CustomSelect
        employees={employees} 
        selectedEmail={formData.email} 
        onSelect
        ={(email) => setFormData({ ...formData, email })} 
      /> */}
        <Select
          value={formData.email}
          onChange={handleSelectChange}
          displayEmpty
          fullWidth
          renderValue={(selectedEmail) => {
            if (!selectedEmail) {
              return <em>Select an employee</em>;
            }
            // Find the employee name by email
            const selectedEmployee = employees.find(emp => emp.email === selectedEmail);
            return selectedEmployee ? selectedEmployee.name : selectedEmail;
          }}
          sx={{
            backgroundColor: colors.primary[400],
            color: colors.grey[100],
            borderRadius: "5px",
            border: `1px solid ${colors.grey[700]}`,
            "& .MuiSelect-icon": {
              color: colors.grey[100],
            },
            "&:focus": {
              backgroundColor: colors.primary[400],
              borderColor: colors.greenAccent[500],
            },
          }}
        >
          <MenuItem value="" disabled>
            Select an employee
          </MenuItem>
          {employees.map(({ email, name }) => (
            <MenuItem
              key={email}
              value={email}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: colors.greenAccent[600],
                  color: colors.grey[100],
                  "&:hover": {
                    backgroundColor: colors.greenAccent[700],
                  },
                },
                "&:hover": {
                  backgroundColor: colors.greenAccent[500],
                  color: colors.grey[100],
                },
              }}
            >
              {name} --- [ {email} ]
            </MenuItem>
          ))}
        </Select>


      <Typography 
        variant="body1" 
        sx={{ 
          color: colors.grey[100],
          marginTop: "15px", 
          marginBottom: "8px"
        }}
      >
        Date:
      </Typography>
      <Box 
        component="input" 
        type="date" 
        name="date" 
        value={formData.date} 
        onChange={handleDateChange} 
        sx={{ 
          width: "100%", 
          padding: "8px", 
          borderRadius: "5px", 
          border: `1px solid ${colors.grey[700]}`, 
          backgroundColor: colors.primary[400],
          color: colors.grey[100],
          "&:focus": {
            outline: "none",
            borderColor: colors.greenAccent[500]
          },

          "&::-webkit-calendar-picker-indicator": {
      filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
    },
    // For Firefox
    "&::-moz-calendar-picker-indicator": {
      filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
    }
        }} 
      />

      <Box 
        sx={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
          gap: "15px", 
          marginTop: "20px" 
        }}
      >
        {formData.records.map((record, index) => (
          <Box 
            key={index} 
            sx={{ 
              padding: "10px", 
             
              borderRadius: "5px", 
              border: `1px solid ${colors.grey[700]}` 
            }}
          >
            <Typography 
              variant="body1" 
              sx={{ 
                color: colors.grey[100],
                marginBottom: "8px"
              }}
            >
              Check-In {index + 1}:
            </Typography>
            <Box 
              component="input" 
              type="time" 
              value={record.check_in.slice(0, 5)} 
              onChange={(e) => handleRecordChange(index, "check_in", e.target.value)} 
              sx={{ 
                width: "100%", 
                padding: "8px", 
                borderRadius: "5px", 
                border: `1px solid ${colors.grey[700]}`, 
                backgroundColor: colors.primary[400],
                color: colors.grey[100],
                "&:focus": {
                  outline: "none",
                  borderColor: colors.greenAccent[500]
                },
                // For Webkit browsers (Chrome, Safari, Edge)
                "&::-webkit-calendar-picker-indicator": {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
                },
                // For Firefox
                "&::-moz-calendar-picker-indicator": {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
                }
              }} 
            />
            <Typography 
              variant="body1" 
              sx={{ 
                color: colors.grey[100],
                marginTop: "8px",
                marginBottom: "8px"
              }}
            >
              Check-Out {index + 1}:
            </Typography>
            <Box 
              component="input" 
              type="time" 
              value={record.check_out.slice(0, 5)} 
              onChange={(e) => handleRecordChange(index, "check_out", e.target.value)} 
              sx={{ 
                width: "100%", 
                padding: "8px", 
                borderRadius: "5px", 
                border: `1px solid ${colors.grey[700]}`, 
                backgroundColor: colors.primary[400],
                color: colors.grey[100],
                "&:focus": {
                  outline: "none",
                  borderColor: colors.greenAccent[500]
                },
                // For Webkit browsers (Chrome, Safari, Edge)
                "&::-webkit-calendar-picker-indicator": {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
                },
                // For Firefox
                "&::-moz-calendar-picker-indicator": {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0)',
                }
              }} 
            />
          </Box>
        ))}
      </Box>

      <Button 
        onClick={handleSubmit} 
        sx={{ 
          width: "100%", 
          padding: "10px", 
          background: colors.greenAccent[600], 
          color: colors.grey[100], 
          borderRadius: "5px", 
          border: "none", 
          cursor: "pointer", 
          marginTop: "20px",
          "&:hover": {
            backgroundColor: colors.greenAccent[700]
          }
        }}
      >
        Submit
      </Button>

      {message && (
        <Typography 
          sx={{ 
            textAlign: "center", 
            color: colors.greenAccent[500], 
            marginTop: "15px" 
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default CheckInOut;